/**
 * page module loader
 */

export class PageDispatchError extends Error {
	
	pageKey : string
	
	constructor( message : string, pageKey : string ) {
		super(message); // (1)
		this.name = "PageDispatchError"; // (2)
		this.pageKey = pageKey
	}
}

/** 
 * pageKey is the page path without origin and file extension, parameters/anchors 
 **/
export function getPageKey( url : string ) : string {

	let pageKey = 'index';

	// remove protocol and domain (origin)
	if ( typeof url == 'string' ) {
		url = url.replace( /^https?:\/\/[^/]+/, '' );
		
		let m = url.match( /^\/([^.#?]+)/ );
		if ( m ) {
			pageKey = m[1];
		}
	}

	return pageKey;
}

export function pageDispatcher( url : string ) : Promise<any> {

	let pageKey = getPageKey( url );
	
	switch ( pageKey ) {
		case 'index':
			// Startseite
			return import(/* webpackChunkName: "page-index" */				'../page-muenzen/page-muenzen' );
	}
	
	return Promise.reject( new PageDispatchError( 'pageDispatcher: pageKey "' + pageKey + '" not found', pageKey ) );
}
